import React from 'react'
import { Row, Col, Calendar } from 'antd';
import HomeList from './components/HomeList';
import Category from '@/components/Category';
import SidePerson from './components/SidePerson'
import Teji from './components/Teji'
import Book from './components/Book'
import './index.less'

class HomeIndexComponent extends React.Component {
  constructor (props) {
    super(props)
  }

  componentDidMount () {
    window.scrollTo(0, 0);
  }

  render () {
    return (
      <Row gutter={20}>
        <Col span={17}>
          <HomeList />
        </Col>
        <Col span={7}>
          <Row gutter={20}>
            <Col span={24}>
              <Row gutter={20}>
                <Col span={24}>
                  <Teji />
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <Book />
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={24}>
                  <SidePerson />
                </Col>
              </Row>
              <Row gutter={20} style={{ marginTop: '18px' }}>
                <Col span={24}>
                  <Category />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default HomeIndexComponent
